import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import TitleSection from 'Views/Page/Content/Modal/Components/TitleSection';
import WhatIfStepNavigator from 'Views/Page/Content/Modal/Components/WhatIfStepNavigator';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDStack } from '@facet-wealth/design';

const styles = (theme) => ({
  root: {},
  label: {},
  fields: {
    padding: theme.spacing(0),
  },
  group: {
    marginBottom: theme.spacing(4),
  },
});

const FacetPlanOutcomeQuickEditEmergencyFundWithStagesLayout = ({
  className,
  classes,
}) => {
  const {
    resource,
    onSubmit,
    saving,
  } = useMetaLayoutContext();

  const { refreshPageContentCollection } = usePageContentContext();

  const {
    loadModalCollectionByLink,
    clearModalCollection,
  } = useModalContext();

  const previousLink = resource.relationship(fr.relationships.previousLink.name)?.link('related');

  return (
    <Box className={classNames(classes.root, className)}>
      <TitleSection />
      <FDStack direction={'column'} spacing={2}>
        <MetaControlField attr={'stageOneAmount'} />
        <MetaControlField attr={'stageThreeAmount'} />
        <MetaControlField attr={'numMonthsExpenses'} />
      </FDStack>
      <WhatIfStepNavigator
        isLoading={saving}
        onNext={async () => {
          const resp = await onSubmit();
          if (resp) {
            clearModalCollection();
            refreshPageContentCollection();
          }
        }}
        onPrevious={(previousLink) ? () => {
          loadModalCollectionByLink(previousLink.url());
        } : null}
      />
    </Box>
  );
};

FacetPlanOutcomeQuickEditEmergencyFundWithStagesLayout.defaultProps = {
  className: '',
};

FacetPlanOutcomeQuickEditEmergencyFundWithStagesLayout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FacetPlanOutcomeQuickEditEmergencyFundWithStagesLayout);
